module.exports = __webpack_public_path__ + "img/broadcast-video-img.afb09ac9.jpg";